import { Grid, styled } from "@mui/material";

const Header = styled(Grid)(({ theme }) => ({
  color: theme.palette.info.main,
  fontSize: "12px",
  fontWeight: 600,
  fontFamily: "Poppins",
  color: "#757E97",
}));

const ClientListHeader = () => {
  return (
    <Grid
      container
      sx={{
        display: { xs: "none", sm: "flex" },
        justifyContent: "space-between",
        padding: "6px 16px",
      }}
    >
      <Header
        item
        sm={3}
        sx={{ display: "flex", gap: "10px", alignItems: "center" }}
      >
        Nom du client
      </Header>
      <Header item sm={3}>
        Adresse email
      </Header>
      <Header item sm={2}>
        Abonnement
      </Header>
      <Header item sm={1}>
        Statut
      </Header>
      <Header item sm={2} sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
        Dernière connexion
      </Header>
      <Header item sm={1} sx={{ textAlign: "right" }}>
        Actions
      </Header>
    </Grid >
  );
};

export default ClientListHeader;
